import { Props } from '../layout.type';

export const LayoutEmpty = ({ children }: Props) => {
  return <div className='max-w-[850px] mx-auto px-4 lg:px-0 min-h-screen pt-8 md:pt-14 pb-10'>{children}</div>;
};
